export default __webpack_public_path__ + "static/media/i015vp.d7b338d1.webp";